import ImageViewer from '@/components/image-viewer/index.vue';
export default {
  props: ['info'],
  components: {
    ImageViewer
  },
  data: () => {
    return {
      showDialog: false,
      status: 'init',
      isCheck: false,
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now();
        }
      }
    };
  },

  computed: {

    images() {
      const image = this.info && this.info.addons && this.info.addons.paymentVouche;
      if (image) {
        return image;
      }
      return [];
    }
  },

  created() {
  },

  methods: {
  }
};
